import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { reloadIfStaleChunkError } from "./utils/chunkReload";

// Catch stale-chunk failures that bypass the React error boundary
// (e.g. dynamic imports rejected outside the Suspense tree).
window.addEventListener("error", (event) => {
  reloadIfStaleChunkError(event.error || event.message);
});
window.addEventListener("unhandledrejection", (event) => {
  reloadIfStaleChunkError(event.reason);
});

const rootElement = document.getElementById("root") as HTMLElement;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// We previously called hydrateRoot when the Puppeteer pre-render had filled
// the root, but that produced React errors #418/#423/#425: the pre-rendered
// HTML contains the fully-rendered page, while the first client render shows
// the <Suspense fallback> spinner because the lazy route chunk has not loaded
// yet. Puppeteer-snapshot HTML lacks the Suspense boundary markers that React
// 18 streaming SSR emits, so hydrateRoot cannot reconcile the two. createRoot
// replaces the pre-rendered DOM cleanly; crawlers still see the static HTML.
ReactDOM.createRoot(rootElement).render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
